import { WorkType } from '../../interfaces/user-work-experience.interface';

// https://cloverdynamics.atlassian.net/browse/FAS2-161
// correct spell 'on-site' btw
export const workTypeLabelPlugin = (label: WorkType) =>
  label === WorkType.ON_SITE ? 'ONSITE' : label;
